import React, { useEffect } from "react"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import formatDateTime from "components/Shared/formatDateTime"
import { getAllergenDetails } from "store/actions/allergensAction"
import placeholderImage from "assets/images/placeholderImage.png"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import { getVehicleDetails } from "store/actions/vehicleAction"

const VehicleDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Vehicle Details `)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      35,
      "vehicle_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  const { loading, vehicleDetails } = useSelector(state => state.Vehicles)
  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getVehicleDetails(payload))
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Col lg={12}>
          <Card className="card_100_24">
            <CardBody>
              <CardTitle className="d-flex align-items-center">
                <BackButton /> {t("Vehicle Details")}
              </CardTitle>
              <p className="text-muted mb-4"></p>
              <div className="table-responsive">
                {loading ? (
                  <ShimmerThumbnail height={300} rounded />
                ) : Object.values(vehicleDetails).length === 0 ? (
                  <p className="text-center my-3">
                    {t("No vehicle details found")}
                  </p>
                ) : (
                  <Table className="table-nowrap mb-0 capitalize_td">
                    <tbody>
                      <tr>
                        <th scope="row">{t("Id")}</th>
                        <td>{vehicleDetails._id}</td>
                      </tr>
                      <tr>
                        <th scope="row">{t("Logo")} </th>
                        <td>
                          <img
                            src={vehicleDetails.logo}
                            width={50}
                            height={50}
                            alt=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">{t("Brand")} </th>
                        <td>
                          {language === "sa"
                            ? vehicleDetails?.brandAr ||
                              vehicleDetails?.brand ||
                              "-"
                            : vehicleDetails?.brand || "-"}
                        </td>
                      </tr>
                      {/* <tr>
                        <th scope="row">{t("Brand(عربي)")}</th>
                        <td>{vehicleDetails?.brandAr}</td>
                      </tr> */}
                      <tr>
                        <th scope="row">{t("Status")}</th>
                        <td>
                          {vehicleDetails?.status === 1 ? (
                            <Badge className="bg-success">{t("Active")}</Badge>
                          ) : (
                            <Badge className="bg-danger">{t("Deactive")}</Badge>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </div>
    </div>
  )
}

export default VehicleDetails
